import { ApiResponse } from "../../../types/api";
import apiClient from "../../apiClient";

export interface Agent {
  id: string;
  name: string;
  email: string;
  phone: string;
  agentId: string;
}

export interface Customer {
  id: string;
  name: string;
  email: string;
  phone: string;
  photo: string | null;
  royalty: number;
  customerType: string;
  dateOfBirth: string | null;
  banStatus: "active" | "temporary_ban" | "permanent_ban" | "under_monitor";
  banEndDate: string | null;
  banRemarks: string | null;
  countryId: string;
  stateId: string;
  playerId: string;
  customerCardNumber: string;
  cashIn: Array<{
    amount: number;
  }>;
}

export const verificationService = {
  verifyAgent: async (agentId: string): Promise<ApiResponse<Agent>> => {
    const response = await apiClient.get(`/agents/agent/${agentId}`);
    return response.data;
  },

  verifyCustomer: async (playerId: string): Promise<ApiResponse<Customer>> => {
    const response = await apiClient.get(`/customers/player/${playerId}`);
    return response.data;
  },
};
